// extracted by mini-css-extract-plugin
export default {"marca":"MarcaDaNyta_marca__mspu0","icone":"MarcaDaNyta_icone__NQEWs","pensando":"MarcaDaNyta_pensando__ZxTG-","pulso":"MarcaDaNyta_pulso__tL+-U"};